import _ from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import api from '../../services/api'
import { REPORT_TYPE_ID_MAP, REPORT_REPORT_TYPE_NAME_MAP } from '../../constants/report'
import useModal from '../../hooks/useModal'

import BasicPieChart from '../../components/charts/PieChart'
import BasicLineChart from '../../components/charts/LineChart'
import { BasicBtn, UpdateAttendanceBtn } from '../../components/Buttons'
import { ContentsBox, FlexItemBox } from '../../components/main/Main.styles'
import { ProgressBar } from '../../components/ProgressBar'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt'

import { ReactComponent as ReportIcon } from '../../assets/images/menu/report_icon.svg'

export default function ReportDetail() {
  const [attendanceInfo, setAttendanceInfo] = useState()
  const [report, setReport] = useState()
  const [statics, setStatics] = useState()
  const { openModal } = useModal()
  const { reportId } = useParams()
  const [query, setQuery] = useSearchParams()
  const reportTypeId = parseInt(query.get('reportTypeId'))
  const date = moment(query.get('date')).format('YYYY-MM-DD')
  const navigate = useNavigate()

  useEffect(() => {

    api.get(`/attendances/${date}`)
      .then(result => setAttendanceInfo(result.data))
      .catch(e => {
        console.error(e)
        openModal({ type: 'alert', props: {isError: true, contents: e.response?.data.message || e.message }})
      })

    api.get(`/reports/${date}/${reportId}`)
      .then(result => setReport(result.data))
      .catch(e => {
        console.error(e)
        openModal({ type: 'alert', props: {isError: true, contents: e.response?.data.message || e.message }})
      })

    api.get(`/reports/infos/performances/${date}`, { params: { reportTypeId } })
      .then(result => setStatics(result.data.statics))
      .catch(e => {
        console.error(e)
        openModal({
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message,
            path: e.response?.status === 404 ? '/main/planner/sessional-plan' : undefined
          }})
      })
  }, [])

  return (
    <ContentsLayout>
      <ReportIcon width='35px' fill='black' style={{ verticalAlign: 'middle', marginRight: '10px' }}/>
      <span style={{ fontWeight: 'bold', fontSize: '1.5em', marginLeft: '10px' }}>{date} {REPORT_REPORT_TYPE_NAME_MAP[reportTypeId]} 리포트</span>
      <div style={{ position: 'absolute', right: 0, display: 'inline-block' }}>
        <BasicBtn
          height='40px'
          width='120px'
          onClick={() => navigate(`modify?reportTypeId=${reportTypeId}&date=${date}`)}
        >수정
        </BasicBtn>
        <BasicBtn
          height='40px'
          width='120px'
          onClick={() => {
            openModal({
              type: 'confirm',
              props: {
                contents: '정말로 삭제하시겠습니까?',
                callbackFun: async () => {
                  await api.delete(`/reports/${date}/${reportId}`)
                    .then(() => navigate('../list'))
                    .catch(e => {
                      console.error(e)
                      openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
                    })

                },
              }
            })
          }}
          style={{ marginLeft: '10px' }}
        >삭제
        </BasicBtn>
      </div>
      <FlexContainer>
        <FlexContentsBox margin='10px 10px 0 0' width={REPORT_TYPE_ID_MAP.DAILY === reportTypeId ? '80%' : '100%'}>
          <FlexContainer style={{ justifyContent: 'center' }}>
            <ul style={{ width: REPORT_TYPE_ID_MAP.DAILY === reportTypeId ? '60%' : '100%', lineHeight: '2.5em', fontWeight: 'bold', marginTop: '10px'}}>
              <li style={{ verticalAlign: 'middle'}}>
                달성률
                <ProgressBar margin='0 10px 0 10px' max='100' value={statics?.completionRate || 0} width='65%' height='15px' />
                <span style={{ fontSize: '0.8em' }}>{statics?.completionRate}%</span>
              </li>
              <li>
                집중도
                <ProgressBar margin='0 10px 0 10px' max='100' value={statics?.intensiveRate || 0} width='65%' height='15px'/>
                <span style={{ fontSize: '0.8em' }}>{statics?.intensiveRate}%</span>
              </li>
              <li>총 {statics?.totalIntensiveTime?.hour}시간 {statics?.totalIntensiveTime?.min}분 학습 {REPORT_TYPE_ID_MAP.DAILY === reportTypeId ? `(${statics?.studyTime})` : ''} </li>
              {
                REPORT_TYPE_ID_MAP.DAILY === reportTypeId
                  ?
                  <li>
                    {
                      _.isEmpty(attendanceInfo)
                        ? '출석 인증 안 함'
                        :
                        attendanceInfo.isLate
                          ?
                          <>
                            <span style={{ color: 'red' }}>지각</span> [{moment(attendanceInfo.createdAt).format('YYYY-MM-DD HH:mm:ss')}]
                          </>
                          : <>
                            <span style={{ color: 'blue' }}>출석</span> [{moment(attendanceInfo.createdAt).format('YYYY-MM-DD HH:mm:ss')}]
                          </>
                    }
                  </li>
                  :
                  <></>
              }
            </ul>
            {
              REPORT_TYPE_ID_MAP.DAILY === reportTypeId
                ?
                <UpdateAttendanceBtn
                  attendanceInfo={attendanceInfo}
                  setAttendanceInfo={setAttendanceInfo}
                  proofOn={date}
                  width='30%'
                />
                :
                <></>

            }
          </FlexContainer>
        </FlexContentsBox>
        {
          REPORT_TYPE_ID_MAP.DAILY !== reportTypeId
            ?
            <FlexContentsBox margin='10px 10px 0 0' width='100%' height= '200px'>
              {
                <BasicLineChart
                  data={[
                    {
                      id: '학습 시간',
                      data: _.map(statics?.studyStatsByPeriod, v => ({ x: moment(v.date).format('MM-DD'), y: (v.studyTime.hour) * 60 + (v.studyTime.min) }))
                    },
                  ]}
                  max={_.every(statics?.studyStatsByPeriod, v => v.studyTime.hour * 60 + v.studyTime.min === 0) ? '100' : undefined}
                  yAxis='분'
                  margin={{ top: 20, right: 90, bottom: 30, left: 50 }}
                  colors='#e5d8bd'
                  isAxisBottom={!(REPORT_TYPE_ID_MAP.DAILY !== reportTypeId && REPORT_TYPE_ID_MAP.WEEKLY !== reportTypeId)}
                  pointSize={REPORT_TYPE_ID_MAP.DAILY !== reportTypeId && REPORT_TYPE_ID_MAP.WEEKLY !== reportTypeId ? 0 : 5}
                />
              }
            </FlexContentsBox>
            :
            <></>
        }
        <FlexContentsBox margin='10px 0 0 0' width={REPORT_TYPE_ID_MAP.DAILY === reportTypeId ? '50%' : '100%'} height= '200px' >
          {
            REPORT_TYPE_ID_MAP.DAILY === reportTypeId
              ? <BasicPieChart
                data={_.map(statics?.timeTrackingStatics, ts => ({ id: ts.dailyLogTypeNameKo, value: ts.usageRate }))}
                margin={{ top: 30, bottom: 30 }}
              />
              :
              <BasicLineChart
                data={[
                  {
                    id: '달성률',
                    data: _.map(statics?.studyStatsByPeriod, ss => ({ x: moment(ss.date).format('MM-DD'), y: ss.completionRate }))
                  },
                  {
                    id: '집중도',
                    data: _.map(statics?.studyStatsByPeriod, ss => ({ x: moment(ss.date).format('MM-DD'), y: ss.intensiveRate }))
                  }
                ]}
                max='100'
                yAxis='%'
                margin={{ top: 20, right: 90, bottom: 30, left: 50 }}
                isAxisBottom={!(REPORT_TYPE_ID_MAP.DAILY !== reportTypeId && REPORT_TYPE_ID_MAP.WEEKLY !== reportTypeId)}
                pointSize={REPORT_TYPE_ID_MAP.DAILY !== reportTypeId && REPORT_TYPE_ID_MAP.WEEKLY !== reportTypeId ? 0 : 5}
              />
          }
        </FlexContentsBox>
      </FlexContainer>
      <FlexContainer>
        <FlexContentsBox margin='10px 10px 0 0' width='100%' alignSelf='flex-start'>
          <ThumbUpOffAltIcon style={{ verticalAlign: 'middle', marginRight: '10px', width: '20px' }}/>
          <b>잘한점</b>
          {report?.feedback?.goodPoints.map((item, idx) => (
            <div key={idx} style={{ whiteSpace: 'pre-wrap', margin: '8px 0' }}>
              <b>{idx + 1}.</b> {item}
              <hr style={{ border: '0', borderTop: '1px solid #ddd', margin: '6px 0' }} />
            </div>
          ))}
        </FlexContentsBox>
        <FlexContentsBox margin='10px 10px 0 0' width='100%' alignSelf='flex-start'>
          <ThumbDownOffAltIcon style={{ verticalAlign: 'middle', marginRight: '10px', width: '20px' }}/>
          <b>아쉬운점 → 본질적인 원인 → 해결책</b>
          {report?.feedback?.improvePoints.map((item, idx) => (
            <div key={idx} style={{ whiteSpace: 'pre-wrap', margin: '8px 0' }}>
              <b>{idx + 1}.</b> {item}
              <hr style={{ border: '0', borderTop: '1px solid #ddd', margin: '6px 0' }} />
            </div>
          ))}
        </FlexContentsBox>
        <FlexContentsBox margin='10px 0 0 0' width='100%' alignSelf='flex-start'>
          <InfoOutlinedIcon style={{ verticalAlign: 'middle', marginRight: '10px', width: '20px' }}/>
          <b>기타</b>
          {report?.feedback?.etc.map((item, idx) => (
            <div key={idx} style={{ whiteSpace: 'pre-wrap', margin: '8px 0' }}>
              <b>{idx + 1}.</b> {item}
              <hr style={{ border: '0', borderTop: '1px solid #ddd', margin: '6px 0' }} />
            </div>
          ))}
        </FlexContentsBox>
      </FlexContainer>
    </ContentsLayout>
  )
}

export const ContentsLayout = styled.div`
  margin: 20px;
  position: relative;
`

const FlexContainer = styled.div`
  display: flex;
`

const FlexContentsBox = styled(ContentsBox, FlexItemBox)`
  align-self: ${(props) => props.alignSelf};
  word-break:break-all;
`